import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import MDTypography from "components/MDTypography";
import SaveModal from "layouts/profile/components/WalletsTab/save-modal"
import SummaryModal from "layouts/profile/components/WalletsTab/summary-modal"
import { useMaterialUIController } from "context";

function WalletsTab() {
  const [controller] = useMaterialUIController();
  const { wallets } = controller;
  const [rows, setRows] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editWallet, setEditWallet] = useState(null);
  const [openSummaryModal, setOpenSummaryModal] = useState(false);

  useEffect(() => { handleWalletChange() }, [wallets]);

  const handleWalletChange = async () => {
    setRows(wallets.map((wallet) => ({
      ...wallet,
      action: (
        <MDBox>
          <MDTypography component="a" href="#" variant="caption" color="info" fontWeight="medium" onClick={() => handleOpenEditModal(wallet)} mr={2}>
            Edit
          </MDTypography>
          <MDTypography component="a" href="#" variant="caption" color="info" fontWeight="medium" onClick={() => handleOpenSummaryModal(wallet)} mr={2}>
            Summary
          </MDTypography>
        </MDBox>
      ),
    })));
  };

  const handleOpenInsertModal = () => {
    setEditWallet(null);
    setOpenModal(true);
  };
  
  const handleOpenEditModal = (wallet) => {
    setEditWallet(wallet);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleOpenSummaryModal = (wallet) => {
    setEditWallet(wallet);
    setOpenSummaryModal(true);
  };

  const handleSummaryClose = () => {
    setOpenSummaryModal(false);
  };
  
  const newButton = (<MDButton variant="outlined" color="info" size="small" onClick={() => handleOpenInsertModal()}>+</MDButton>);
  const columns = [
    { Header: "Name", accessor: "name", width: "45%", align: "left" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  return (
    <MDBox pt={3} sx={{ overflowX: "auto", display: "block" }}>
      <DataTable table={{ columns, rows }} title="Wallets:" entriesPerPage={false} showTotalEntries={false} newButton={newButton} />
      <SaveModal open={openModal} handleClose={() => handleClose()} wallet={editWallet} />
      <SummaryModal open={openSummaryModal} handleClose={() => handleSummaryClose()} wallet={editWallet} />
    </MDBox>
  );
}

export default WalletsTab;
